import { DrugScreenResult } from '@/types/drugScreen';

import snakeCaseToTitleCase from './snakeToTitleCase';
import { capitalizeFirstLetter } from './strings';

export const getDrugScreenResultTitle = (result: DrugScreenResult, substances: string[] = []) => {
  let testResult = snakeCaseToTitleCase(result).replace(/\bFormal\s*/gi, '');

  if (!['Positive', 'Negative'].includes(testResult) || !substances.length) {
    return testResult;
  }

  if (testResult === 'Positive' && substances.length > 1) {
    testResult = 'Positive for one or more of';
  } else {
    testResult = `${testResult} for`;
  }
  return `${testResult} ${capitalizeFirstLetter(substances.join(', '))}`;
};
